<div class="inbuilt-visual-wrapper-v2">
  <div class="card-header" *ngIf="heading">
    <div class="header-content">
      <h4 class="card-title">{{ heading }}</h4>
      <a 
        *ngIf="hasNavigationLink" 
        class="more-details-link" 
        [matTooltip]="navigationTooltip"
        matTooltipPosition="above"
        (click)="handleNavigationClick()" 
      >
        <mat-icon class="info-icon">info</mat-icon>
        More Info
      </a>
    </div>
  </div>

  <div class="card-body">
    <ng-content></ng-content>
  </div>
</div>
